import axios from 'axios';

// Resolve backend API URL dynamically for mobile devices and LAN access
const getBaseUrl = () => {
  let url = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
  if (typeof window !== 'undefined' && window.location && window.location.hostname) {
    const currentHost = window.location.hostname;
    // If accessed on a mobile phone or network IP and the URL specifies localhost, replace with the current host
    if (currentHost !== 'localhost' && currentHost !== '127.0.0.1' && url.includes('localhost')) {
      url = url.replace('localhost', currentHost);
    }
  }
  return url;
};

const BASE = getBaseUrl();

const axiosClient = axios.create({
  baseURL: BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request Interceptor
axiosClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('adminToken');

    try {
      console.log('API REQUEST', {
        method: config.method,
        url: `${config.baseURL}${config.url}`,
        payload: config.data,
        tokenAttached: !!token,
      });
    } catch (e) {}

    // Ensure headers object exists
    config.headers = config.headers || {};

    // Only attach admin token for admin routes and when Authorization not already set by caller.
    // This prevents accidentally sending adminToken as the student token.
    const reqUrl = typeof config.url === 'string' ? config.url : '';
    if (token && reqUrl.startsWith('/admin') && !config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response Interceptor
axiosClient.interceptors.response.use(
  (response) => {
    try {
      console.log('API RESPONSE', {
        url: response.config?.url,
        status: response.status,
        data: response.data,
      });
    } catch (e) {}

    // Unwrap backend response if it follows { success, data }
    if (response.data && typeof response.data.success === 'boolean') {
      return {
        ...response,
        data: response.data.data,
      };
    }

    return response;
  },
  (error) => {
    try {
      console.error('API ERROR', {
        url: error.config?.url,
        status: error.response?.status,
        data: error.response?.data,
      });
    } catch (e) {}

    // Only clear admin auth and redirect to admin login when the 401 originates
    // from an admin route. This avoids logging out admins when student endpoints
    // return 401 (e.g., missing/invalid student token).
    if (error.response?.status === 401) {
      const reqUrl = error.config?.url || '';
      if (typeof reqUrl === 'string' && reqUrl.startsWith('/admin')) {
        localStorage.removeItem('adminToken');
        localStorage.removeItem('adminUser');
        localStorage.removeItem('adminLoginTime');

        setTimeout(() => {
          window.location.href = '/admin/login';
        }, 100);
      }
    }

    return Promise.reject(error);
  }
);

export default axiosClient;